import React from 'react';

const SliderArrow = ({ url, onClick, width, height, className }) => (
  <div className={`a-arrow ${className} hover-bg-near-white bg-animate t-pv4 t-ph0`} onClick={onClick}>
    <img src={url} className="dib v-mid" width={width} height={height} />
  </div>
);

SliderArrow.defaultProps = {
  url: '/images/webreader/arrow-left.svg',
  className: '',
  width: '48px',
  height: '48px'
};

export default SliderArrow;
